import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';
import { BRAND_NAME, BRAND_TAGLINE, BRAND_LOGO_URL, BRAND_LOGIN_BG_URL } from '@/config/constants';
import './AuthLayout.css';

const { Content } = Layout;

const AuthLayout = () => {
  return (
    <Layout
      className="auth-layout"
      style={{ backgroundImage: `url(${BRAND_LOGIN_BG_URL})` }}
    >
      <Content className="auth-content">
        <div className="auth-container">
          <div className="auth-header">
            <img
              className="auth-brand-logo"
              src={BRAND_LOGO_URL}
              alt=""
              width={80}
              height={80}
              decoding="async"
            />
            <h1 className="auth-title">{BRAND_NAME}</h1>
            <p className="auth-subtitle">{BRAND_TAGLINE}</p>
          </div>
          <Outlet />
        </div>
      </Content>
    </Layout>
  );
};

export default AuthLayout;

